import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-flyout-menu-header',
  templateUrl: 'flyout-menu-header.component.html',
  styleUrls: ['flyout-menu-header.component.scss']
})
export class FlyoutMenuHeaderComponent {
}
